import dateToDateStr from 'app/utils/date/dateToDateStr'
import requestConfig from 'app/requests/ServiceCenter/ServiceCenter.requests'
import SkyNetDataGrid from 'app/shared-components/SkyNetDataGrid'
import useDataGridSource from 'app/shared-components/SkyNetMasterDataGrid/hooks/useDataGridSource'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useStyles from '../ServiceCentersDemoScenarioEditor.styles'
import columns from './containerStatusBreakdown.columns'

const ContainerStatusBreakdown = ({
    serviceCenterId,
}: Readonly<{ serviceCenterId: number }>) => {
    const {
        classes,
    } = useStyles()

    const dataSource = useDataGridSource({
        request: requestConfig.getContainerStatusBreakdown({
            serviceCenterId,
        }),
        key: RequestKeys.getContainerStatusBreakdown,
    })

    return (
        <SkyNetDataGrid
            persistentKey="demo-containerStatusBreakdown-table"
            columns={columns}
            customDataSource={dataSource}
            toolbarProps={{
                title: `Container Status Breakdown As of ${dateToDateStr(Date.now())}`,
                showClearSort: false,
            }}
            getRowId={(row) => {
                // data is missing id in each record
                return JSON.stringify(row)
            }}
            classNames={{
                container: classes.tableContainer,
                tableWrapper: classes.tableWrapper,
            }}
        />
    )
}

export default ContainerStatusBreakdown
